import styled from 'styled-components';
import { TabList } from '@bexs/dollar';

export const TabListWrapper = styled(TabList)`
  border-color: ${({ theme }) => theme.colors.primary};
  span {
    background-color: ${({ theme }) => theme.colors.primary} !important;
  }
`;
